import { RamlServicesBaggage, ServiceStatusCodeType } from '@common/interfaces';
import { CurrentCartState } from '@common/store';
import { Bound, BoundFlightsInner, Traveler } from 'src/sdk-reservation';

export namespace TestData_BOUND {
  const defaultFlight: Required<BoundFlightsInner> = {
    id: 'BOUNDXX',
    cabin: 'business',
    bookingClass: '',
    statusCode: '',
    statusType: 'confirmed',
    departureDaysDifferenceByBound: 0,
    arrivalDaysDifferenceByFlight: 0,
    estimatedArrivalDaysDifferenceByFlight: 0,
    connectionTime: 0,
    isMultiAirportConnection: false,
    isFlown: false,
    operationStatus: {},
    marketingAirlineCode: '',
    marketingFlightNumber: '',
    operatingAirlineCode: '',
    operatingAirlineName: '',
    departure: { locationCode: 'TYO', locationName: 'とうきょう', dateTime: '2023-01-01 12:34:56' },
    arrival: { locationCode: 'NYC', locationName: 'ニューヨーク', dateTime: '2023-01-01 12:34:56' },
    aircraftCode: '',
    aircraftName: '',
    isSmallAircraft: false,
    duration: 0,
    isLateNightDeparture: false,
    isOpenSegment: false,
    isSubjectToGovernmentApproval: false,
    stops: [],
    aircraftConfigurationVersion: '',
    flightServices: {},
    meal: {},
    isScheduleChanged: false,
    scheduleChangeType: 'waitlistedTimeChanged',
    isUpgraded: false,
    upgradeType: 'plusgrade',
    isDynamicWaiverApplicable: false,
    isStarAllianceOperated: false,
    availableCabins: [],
    isNhGroupMarketing: false,
    isNhGroupOperated: false,
    isNeededToSupplementBookingClass: false,
    fareInfos: {},
    upgradableCabins: [],
    isDepartedWithin48Hours: false,
    isJapanDomesticFlight: false,
    upgradeWaitlisted: {},
  };

  export const defaultBound: Required<Bound> = {
    airBoundId: 'BOUND001',
    travelSolutionId: '',
    originLocationCode: 'TYO',
    destinationLocationCode: 'PHX',
    originLocationName: 'とうきょう',
    originDepartureDateTime: "2023-08-31'12:34:56",
    originDepartureEstimatedDateTime: "2023-09-01'11:22:33",
    destinationLocationName: 'フェニックス',
    destinationArrivalDateTime: "2023-09-02'09:08:07",
    destinationArrivalEstimatedDateTime: "2023-09-01'06:07:08",
    destinationArrivalDaysDifference: 1,
    destinationArrivalEstimatedDaysDifference: 1,
    flights: [defaultFlight],
    duration: 0,
    isOtherMethodsConnection: false,
    quotaType: 'enough',
    quota: 0,
    isContainedDelayedFlight: false,
    isContainedEarlyDepartureFlight: false,
    numberOfConnections: 0,
    operatingAirlines: [],
    isAllStarAllianceOperated: false,
    isAllNhGroupOperated: false,
    isContainedSubjectToGovernmentApproval: false,
    isContainedWaitlisted: false,
    isFlix: false,
    disruptionStatus: {},
    isNotPassedChangeableTimeLimit: false,
    isContainedChineseSegment: false,
    cancel: {},
    delay: {},
    earlyDeparture: {},
  };

  export const flight1: Required<BoundFlightsInner> = { ...defaultFlight, id: 'ID001' };
  export const flight2: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID002',
    cabin: '',
    departure: { locationCode: 'NYC', locationName: 'ニューヨーク', dateTime: '2023-01-01 12:34:56' },
    arrival: { locationCode: 'PHX', locationName: 'フェニックス', dateTime: '2023-01-02 12:34:56' },
  };
  export const flight3: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID003',
    cabin: 'first',
    departure: { locationCode: 'NYC', locationName: 'ニューヨーク', dateTime: '2023-01-03 12:34:56' },
    arrival: { locationCode: 'PHX', locationName: 'フェニックス', dateTime: '2023-01-04 12:34:56' },
  };

  export const flight4: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID004',
    cabin: '',
    departure: { locationCode: 'TYO', locationName: '東京', dateTime: '2023-01-05 12:34:56' },
    arrival: { locationCode: 'OSA', locationName: '大阪', dateTime: '2023-01-06 12:34:56' },
  };

  export const flight5: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID005',
    cabin: 'business',
    departure: { locationCode: 'XOSA', locationName: '大阪', dateTime: '2023-01-07 12:34:56' }, //マスターから見つからないようにする
    arrival: { locationCode: 'XNGO', locationName: '名古屋', dateTime: '2023-01-08 12:34:56' }, //マスターから見つからないようにする
  };
  export const flight6: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID006',
    cabin: 'first',
    departure: { locationCode: 'NGO', locationName: '名古屋', dateTime: '2023-01-09 12:34:56' },
    arrival: { locationCode: 'CTS', locationName: '札幌', dateTime: '2023-01-10 12:34:56' },
  };

  export const flight7: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'ID007',
    cabin: 'first',
    departure: { locationCode: 'SEA', locationName: 'シアトル', dateTime: '2024-01-01 10:00:00' },
    arrival: { locationCode: 'CTS', locationName: '札幌', dateTime: '2024-01-03 13:00:00' },
  };

  export const flightMexico1: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'IDM001',
    cabin: 'first',
    departure: {
      locationCode: 'MEX',
      locationName: 'メキシコ',
      dateTime: '2023-01-01 12:34:56',
      country2letterCode: 'MX',
    },
    arrival: { locationCode: 'CTS', locationName: '札幌', dateTime: '2023-01-10 12:34:56' },
  };
  export const flightMexico2: Required<BoundFlightsInner> = {
    ...defaultFlight,
    id: 'IDM002',
    cabin: 'first',
    departure: { locationCode: 'MEX', locationName: '名古屋', dateTime: '2023-01-01 12:34:56' },
    arrival: {
      locationCode: 'MEX',
      locationName: 'メキシコ',
      dateTime: '2023-01-10 12:34:56',
      country2letterCode: 'MX',
    },
  };

  export const bound1: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M5101',
    flights: [flight1, flight3],
  };

  export const bound2: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M5102',
    flights: [flight1, flight2],
  };

  export const bound3: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M5103',
    flights: [flight4, flight5, flight6],
  };

  export const bound4: Required<Bound> = {
    ...defaultBound,
    originLocationCode: 'GUM',
    originLocationName: 'ぐあむ',
    destinationLocationCode: 'MOW',
    destinationLocationName: 'もすくわ',
    airBoundId: 'BOUND_R01M5104',
    flights: [flight1],
  };
  export const bound5: Required<Bound> = {
    ...defaultBound,
    originLocationCode: 'PAR',
    originLocationName: 'ぱり',
    destinationLocationCode: 'YVR',
    destinationLocationName: 'ばんくーばー',
    airBoundId: 'BOUND_R01M5105',
    flights: [flight1],
  };
  export const bound6: Required<Bound> = {
    ...defaultBound,
    originLocationCode: 'SEA',
    originLocationName: 'しあとる',
    destinationLocationCode: 'FSZ',
    destinationLocationName: 'しずおか',
    airBoundId: 'BOUND_R01M5106',
    flights: [flight1],
  };
  export const bound7: Required<Bound> = {
    ...defaultBound,
    originLocationCode: 'SEA',
    originLocationName: 'しあとる',
    destinationLocationCode: 'FSZ',
    destinationLocationName: 'しずおか',
    originDepartureDateTime: "2024-01-01'T'10:00:00",
    destinationArrivalDateTime: "2024-01-02'T'10:00:00",
    airBoundId: 'BOUND_R01M5106',
    flights: [{ ...flight7 }],
  };

  export const BOUND_R01M60_1: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M60_1',
    flights: [flight1],
  };
  export const BOUND_R01M60_1_NH: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M60_1',
    flights: [{ ...flight1, isNhGroupOperated: true }],
  };
  export const BOUND_R01M60_2: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M60_2',
    flights: [flightMexico1],
  };
  export const BOUND_R01M60_3: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M60_3',
    flights: [flightMexico2],
  };
  export const BOUND_R01M60_4: Required<Bound> = {
    ...defaultBound,
    airBoundId: 'BOUND_R01M60_4',
    flights: [flightMexico2, flightMexico1],
  };
}
